// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import store from '@/store/store'
import axios from '@/axios/axios.js'
import Clipboard from 'clipboard'
import VueWechatTitle from 'vue-wechat-title'
import 'babel-polyfill'
import {
  resizeRem
} from './util/util'
import promise from 'es6-promise'
require('es6-promise').polyfill()
promise.polyfill()
Vue.use(VueWechatTitle)

Vue.prototype.Clipboard = Clipboard
Vue.config.productionTip = false
Vue.prototype.$axios = axios
/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  store, // 使用store
  components: { App },
  template: '<App/>'
})

resizeRem()
window.addEventListener('resize', function () {
  resizeRem()
})



// WEBPACK FOOTER //
// ./src/main.js